import getStorageData from "../Utils/getStorageData";
import getHooks from "../hooks";
import { useEffect } from "react";
import { Images } from "./images";
import { getDashoboardPermissions } from "../Utils/searchApiCall";
import { useSelector } from "react-redux";

const useRoutes = () => {
    const permissionsChange = useSelector((state) => state.APIResponse.changePermission);
    console.log("permissionsChange", permissionsChange);
    const userType = getStorageData().userType;
    const menuPermissions = getStorageData().menuPermissions;
    const selectedPremiseID = getStorageData().selectedPremiseID;
    console.log("menuPermissions", menuPermissions);
    let route = [
        {
            img: Images.AdminDashboard,
            activeImg: Images.ActiveAdminDashboard,
            path: "/dashboard/request-dashboard",
            name: "Dashboard",
            isShow: 1
        },

        {
            img: Images.AdminDashboard,
            activeImg: Images.ActiveAdminDashboard,
            path: "/dashboard/request-dashboard/device-dashboard",
            name: "User & Device Dashboard",
            isShow: 0
        },
        {
            img: Images.SubAdmin,
            activeImg: Images.ActiveSubAdmin,
            path: "/users",
            name: "Users",
            isShow: 1
        },
        {
            img: Images.SubAdmin,
            activeImg: Images.ActiveSubAdmin,
            path: "/users/profile/:id",
            name: "Profile List",
            isShow: 0
        },
        {
            img: Images.SubAdmin,
            activeImg: Images.ActiveSubAdmin,
            path: "/users/profile/device/:slaveId",
            name: "Profile List",
            isShow: 0
        },
        {
            img: Images.Premises,
            activeImg: Images.ActivePremises,
            path: "/admins",
            name: "Admin",
            isShow: 1
        },
        {
            img: Images.staticOTP,
            activeImg: Images.ActiveStaticOTP,
            path: "/static-otp",
            name: "Static OTP",
            isShow: 1
        },
        {
            img: Images.Logs,
            activeImg: Images.ActiveLogs,
            path: "/logs",
            name: "Logs",
            isShow: 1
        },
        {
            img: Images.Firmware,
            activeImg: Images.ActiveFirmware,
            path: "/firmware",
            name: "Firmware",
            isShow: 0
        },
        {
            img: Images.DebugDevice,
            activeImg: Images.ActiveDebugDevice,
            path: "/debug-device",
            name: "Debug Device",
            isShow: 1
        },
        {
            // Placeholder icon — reusing Logs visuals until a polling-specific
            // icon is added to the asset set.
            img: Images.Logs,
            activeImg: Images.ActiveLogs,
            path: "/polling",
            name: "Polling",
            isShow: 1
        },
        {
            // OTA verification dashboard — reusing the Firmware icon since
            // OTA is the firmware-delivery side of the same feature.
            img: Images.Firmware,
            activeImg: Images.ActiveFirmware,
            path: "/ota",
            name: "OTA",
            isShow: 1
        },
        {
            // Fleet migrate status (Ram 2026-08-08) — place-wise migrated/
            // pending counts + master-ready. Same icon family as OTA.
            img: Images.Firmware,
            activeImg: Images.ActiveFirmware,
            path: "/migrate-status",
            name: "Migration Tracker",
            isShow: 1
        },
        {
            img: Images.DebugDevice,
            activeImg: Images.ActiveDebugDevice,
            path: "/debug-device-details/:slave",
            name: "Debug Device",
            isShow: 0
        },  
        {
            img: Images.Settings,
            activeImg: Images.ActiveSetting,
            path: "/settings",
            name: "Settings",
            isShow: 0
        },
    ];
    let hotelRoute = [];
    // console.log("hotelRoute", hotelRoute);
    const hotelUserRoute = [
        {
            img: Images.Dashboard,
            activeImg: Images.ActiveDashboard,
            path: "/dashboard",
            name: "Dashboard",
            menuName: "DASHBOARD",
            isShow: 1,
            // handleClick: () => handleClick(),
        },
        {
            img: Images.ControlPanel,
            activeImg: Images.ActiveControlPanel,
            path: "/control-panel",
            name: "Control Panel",
            menuName: "CONTROL-PANEL",
            isShow: selectedPremiseID && menuPermissions?.includes("CONTROL-PANEL") ? 1 : 0,
            // handleClick: () => handleClick(),
        },
        {
            img: require("../assets/images/Icon-rooms.png"),
            activeImg: require("../assets/images/Icons_active_rooms.png"),
            path: "/rooms",
            name: "Rooms",
            menuName: "ROOMS",
            isShow: selectedPremiseID && menuPermissions?.includes("ROOMS") ? 1 : 0,
            // handleClick: () => handleClick(),
        },
        {
            img: Images.Settings,
            activeImg: Images.ActiveSetting,
            path: "/settings",
            name: "Settings",
            menuName: "SETTING",
            isShow: selectedPremiseID && menuPermissions?.includes("SETTING") ? 1 : 0
        },
    ]


    useEffect(() => {
        console.log("call useEffect");

        if (userType === 4 && !permissionsChange) {
            hotelRoute = hotelUserRoute.filter((item) => getStorageData()?.menuPermissions?.includes(item.menuName))
            console.log("hotelRoute", hotelRoute);
            window.location.reload();
        }
    }, [permissionsChange])

    const handleClick = (path) => {
        console.log("window", window);
        window.location.reload();
    }

    return route;
}

export default useRoutes;